import { render } from "./UserStatusEdit.vue?vue&type=template&id=347a32fa&scoped=true"
import script from "./UserStatusEdit.vue?vue&type=script&lang=js"
export * from "./UserStatusEdit.vue?vue&type=script&lang=js"

import "./UserStatusEdit.vue?vue&type=style&index=0&id=347a32fa&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347a32fa"]])

export default __exports__